// src/products/analysis/services/secService.js
// Utility helpers for interacting with SEC proxy endpoints
import { getAuthHeaders } from '../../../services/authService';

const API_BASE_URL = '/api/analysis/sec';

const checkResponseType = (response) => {
  const contentType = response.headers.get('content-type') || '';
  if (contentType.includes('text/html')) {
    throw new Error(
      'Backend API not available. Please ensure the backend proxy is running or deploy to Vercel.'
    );
  }
};

export const searchPrivateCompanies = async (query) => {
  const trimmed = query.trim();
  if (trimmed.length < 2) {
    throw new Error('Please enter at least 2 characters to search.');
  }

  const headers = await getAuthHeaders();
  const response = await fetch(`${API_BASE_URL}/search?q=${encodeURIComponent(trimmed)}`, {
    headers
  });

  checkResponseType(response);

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'Failed to search SEC companies.');
  }

  const data = await response.json();
  return data.results || [];
};

export const getCompanyDetails = async (cik) => {
  const headers = await getAuthHeaders();
  const response = await fetch(`${API_BASE_URL}/company?cik=${encodeURIComponent(cik)}`, {
    headers
  });

  checkResponseType(response);

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'Failed to load SEC company details.');
  }

  return response.json();
};

export const getCrowdfundingFilings = async ({ days = 30, limit = 50, portal } = {}) => {
  const headers = await getAuthHeaders();
  const params = new URLSearchParams();
  if (days) params.append('days', String(days));
  if (limit) params.append('limit', String(limit));
  if (portal) params.append('portal', portal);

  const response = await fetch(`${API_BASE_URL}/crowdfunding?${params.toString()}`, {
    headers
  });

  checkResponseType(response);

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.error || 'Failed to load crowdfunding filings.');
  }

  return response.json();
};

const secService = {
  searchPrivateCompanies,
  getCompanyDetails,
  getCrowdfundingFilings
};

export default secService;


